import React from 'react';
import { Link } from 'lucide-react';

const ResponseBadge = ({ response }) => {
  if (!response) return null;
  
  const getColorClass = (value) => {
    switch (value) {
      case 'required': return 'bg-green-100 text-green-800';
      case 'nice_to_have': return 'bg-blue-100 text-blue-800';
      case 'not_needed': return 'bg-gray-100 text-gray-800';
      case 'dont_know': return 'bg-amber-100 text-amber-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span className={`text-xs px-2 py-1 rounded-full ml-2 ${getColorClass(response.response_value)}`}>
      {response.response_value?.replace('_', ' ')}
    </span>
  );
};

const TeamResponsesSummary = ({ responses = [] }) => {
  const summary = responses.reduce((acc, response) => {
    acc[response.response_value] = (acc[response.response_value] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="text-xs text-gray-600 mt-1 ml-6">
      Team responses: {Object.entries(summary).map(([value, count], idx) => (
        <span key={value}>
          {idx > 0 && ', '}
          {count}x {value.replace('_', ' ')}
        </span>
      ))}
    </div>
  );
};

const DependencyIndicator = ({
    feature,
    userResponse,
    teamResponses = [],
    featureDependencies = {},
    dependentFeatures = {},
    onNavigateToFeature,
    organization
  }) => {
    const dependencies = featureDependencies[feature.reference] || [];
    
    const shouldShowDependencies = 
      dependencies.length > 0 && 
      userResponse?.response_value === 'required';
  
    if (!shouldShowDependencies) return null;
  
    return (
      <div className="space-y-4 mt-4 mb-8"> {/* Added mb-8 for more bottom margin */}
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <div className="flex items-center gap-2 mb-3">
            <Link className="w-4 h-4 text-gray-600" />
            <span className="text-sm font-medium text-gray-900">Dependencies</span>
          </div>
          <div className="space-y-3">
            {dependencies.map(dep => (
              <div key={dep.required_feature_reference} className="ml-4">
                <div className="flex items-center">
                  <button
                    onClick={() => onNavigateToFeature?.(dep.required_feature_reference)}
                    className="text-sm text-blue-600 hover:underline"
                  >
                    {dep.name}
                  </button>
                  {dep.is_system_dependency && (
                    <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                      System
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

export default DependencyIndicator;